import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Question = ({ questionData, index }) => {
//  console.log(questionData)
    const {id, question, options, correctAnswer } = questionData;
    // check correct answer
    const checkCorrectAnswer = (value) => {
        if (correctAnswer === value) {
            toast("Correct answer!");
        }
        else {
            toast('Wrong answer!')
        }
    }
    // show correct answer
    const showCorrectAnswer = () => {
        toast(`Correct answer: ${correctAnswer}`);
    }
    return (
        <div className='rounded shadow border  w-11/12 mx-auto'>
            <div className=' p-4 rounded-t bg-blue-800 text-white text-left flex justify-between items-center gap-4'>
                <h2 className='text-xl font-bold '><span className='px-2 py-1 bg-slate-700 rounded mb-2'>Question {index + 1}</span><br></br> <span className='text-xl font-medium'>{question}</span></h2>
                <p onClick={()=>showCorrectAnswer()} className='cursor-pointer w-[40px] bg-slate-700 text-white flex justify-center items-center px-4 rounded h-[30px]'> <FontAwesomeIcon icon={faEye} /></p>
            </div>
            <div className='p-4'>
                {options.map((value) => <div key={value} className='flex gap-4 p-4'>
                    <input onClick={()=>checkCorrectAnswer(value)} type="radio" name={id} value={value} className="radio  radio-primary" />
                    <p className='text-left'>{value}</p>
                </div>)}
            </div>
            <ToastContainer />
        </div>
    );
};

export default Question;